import { render } from "./wMenuItem.vue?vue&type=template&id=ce4f82ac&ts=true"
import script from "./wMenuItem.vue?vue&type=script&lang=ts"
export * from "./wMenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__